// extracted by mini-css-extract-plugin
module.exports = {"box_container":"Trade_box_container__3vXgB","stats":"Trade_stats__1UC8P"};